<template>
  <session-goal-focus
    :enabled="enabled"
    :goal="goal"
    :post="post"
    :me="me"
    :session="session"
    @save:post="emit('save:post', $event)"
    @add:attachment="emit('add:attachment', $event)"
    @create:attachment="emit('create:attachment', $event)"
    @delete:attachment="emit('delete:attachment', $event)"
  />
</template>

<script lang="ts" setup>
  import { computed, PropType } from 'vue'
  import SessionGoalFocus from '../components/SessionGoalFocus.vue'

  const emit = defineEmits([
    'save:post',
    'add:attachment',
    'create:attachment',
    'delete:attachment',
  ])

  const props = defineProps({
    enabled: {
      type: Boolean,
      required: true,
    },

    goal: {
      type: Object as PropType<Goal>,
      required: true,
    },

    me: {
      type: Object as PropType<User>,
      required: true,
    },

    session: {
      type: Object as PropType<Session>,
      required: true,
    },
  })

  const post = computed(() => {
    return props.session.posts.find((p) => p.goal?.id === props.goal?.id)
  })
</script>
